import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useGreeting() {
  const { t, i18n } = useTranslation();

  const greeting = useMemo(() => {
    const hour = new Date().getHours();
    if (hour < 12) return t('dashboard.greeting.morning');
    if (hour < 18) return t('dashboard.greeting.afternoon');
    return t('dashboard.greeting.evening');
    // i18n.language is a dependency so the greeting re-renders on a locale switch.
  }, [t, i18n.language]);

  const formattedDate = useMemo(() => {
    // Follow the app's language, not the browser's. This used to be hardcoded
    // 'en-US', so the date under the greeting stayed English ("Monday, July 27")
    // even with the whole dashboard in French. fr-CA gives "lundi 27 juillet".
    const locale = i18n.language?.startsWith('fr') ? 'fr-CA' : 'en-CA';
    return new Date().toLocaleDateString(locale, {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
    });
  }, [i18n.language]);

  return { greeting, formattedDate };
}

export default useGreeting;
